// Legacy ICON_PATHS.MISSING_STATES: the light picture and its `_dark` twin, as BaseTable's no-data-icon / no-data-icon-dark.
import type { NoDataIllustration } from '@radish/ui-web';

/** The missing-state picture pair named `missing_state_<name>` (legacy `ICON_PATHS.MISSING_STATES.{LIGHT,DARK}`). */
export function missingState(name: string): NoDataIllustration {
  return { light: `/assets/missing-states/light/missing_state_${name}.svg`, dark: `/assets/missing-states/dark/missing_state_${name}_dark.svg` };
}
